import axios from "axios";
import { IP } from "../index.js";
// 查询用户账号
export async function selectspuser(data) {
  var resp = await axios.post(`${IP}/admin/sup/selectAll`, data);
  return resp.data.data;
}


//开通账号
export async function addspuser(form) {
  var resp = await axios.post(`${IP}/admin/sup/add`, {
    roleId: form.roleId,
    userId:0,
    sup_username: form.sup_username,
    sup_password: form.sup_password,
    supplier_phone: form.supplier_phone,
    message: form.message,
    storeId:0,
  });
  return resp.data;
}

//修改账号
export async function updatespuser(form) {
  var resp = await axios.post(`${IP}/admin/sup/update`, {
    id: form.id,
    userId: form.userId,
    roleId: form.roleId,
    sup_username: form.sup_username,
    sup_password: form.sup_password,
    supplier_phone: form.supplier_phone,
    message: form.message,
    storeId: form.storeId,
  });
  return resp.data;
}

// 删除用户
export async function deletespuser(id) {
  var resp = await axios.post(`${IP}/admin/sup/delete`, {
    id,
  });
  return resp;
}
